import { loadingController, modalController } from "@ionic/vue"
import Five from "@/views/speedVideo/Five.vue"
import Nine from "@/views/speedVideo/Nine.vue"
import BeforeTest from "@/views/speedVideo/BeforeTest.vue"
import Sign from "@/views/speedVideo/Sign.vue"
import CutBox from "@/views/speedVideo/CutBox.vue"
import Mixture from "@/views/speedVideo/Mixture.vue"
import AfterTest from "@/views/speedVideo/AfterTest.vue"
import Review from "@/views/speedVideo/Review.vue"
import Paraphrase from "@/views/speedVideo/Paraphrase.vue"
import { useStorage } from "@vueuse/core"
import { Ref } from "vue"
import { useMsgStore } from "@/shore"
import router from "@/router"

interface pageItem {
  page: string
  params: any
  listener?: any
  currentPage?: string
}

interface PageMapType {
  [key: string]: any
}

/**
 * five          5
 * nine          9
 * beforeTest    2
 * sign          3
 * cutBox        4
 * mix           6
 * afterTest     7
 * review        8
 *
 *
 * */

// 最上层页面操作列表
const operationList: Ref<Record<string, any>[]> = useStorage("operationList", [])

// 跳转页面列表
const pageList: Ref<pageItem[]> = useStorage("pageList", [])
const componentOptions = useStorage("componentOptions", {})

// 跳转页面修改
function queuePageChange(page: string, params?: any) {
  const pageIndex = pageList.value.findIndex((item) => item.page === page)
  params && pageList.value.splice(pageIndex, 1, { page, params })
  pageList.value = pageList.value.slice(0, pageIndex + 1)
  componentOptions.value = pageList.value[pageIndex]

  console.log(componentOptions.value)
}

// 跳转页面入队
function queuePagePush(item: pageItem) {
  operationList.value = []
  pageList.value.push(item)
  componentOptions.value = item
  console.log(componentOptions.value)
}

// 最顶层操作入队
function queueOperationPush(item: any) {
  operationList.value.push(JSON.parse(JSON.stringify(item)))
}

// 跳转页面队尾出队
function queuePagePop(params: any) {
  operationList.value = []
  pageList.value.pop()
  console.log(pageList.value)
  if (pageList.value.length > 0) {
    componentOptions.value = pageList.value[pageList.value.length - 1]
    params ? (componentOptions.value.props = params) : componentOptions.value
    console.log(componentOptions.value)
  } else {
    router?.replace("/TeacherIndex")
    // location.replace("/TeacherIndex")
  }
}

// 跳转页面清空
function queuePageClear() {
  operationList.value = []
  pageList.value = []
  componentOptions.value = {}
  location.replace("/TeacherIndex")
}

function newQueuePageClear() {
  operationList.value = []
  pageList.value = []
  componentOptions.value = {}
  localStorage.removeItem("pageList")
}

// 跳转页面对首出队并打开
async function queuePageShift(pageMap: PageMapType, list: pageItem[]) {
  if (list.length > 0) {
    const item = list.shift() as pageItem
    const modal = await modalController.create({
      component: pageMap[item.page],
      componentProps: item?.params ? { ...item.params, isRefresh: true } : undefined,
      cssClass: "modal_controller_class",
    })
    await modal.present()

    if (item.listener && item.currentPage) {
      useMsgStore().runMessageHandler(item.currentPage, {
        fn: item.listener,
        params: [modal],
      })
    }
  }
}

// 顶层操作执行
function queueOperationShift(list: Record<string, any>[]) {
  return new Promise((resolve) => {
    if (list.length > 0) {
      const message = list.shift() as Record<string, any>
      console.log("执行操作", message)

      if (message.fn === "onShowParaphraseSync" || message.fn === "onSelectSync") {
        message.params.push(true)
      }
      // useMsgStore().runMessageHandler(message.module, message)
    }
    resolve(true)
  })
}

// 还原页面
async function queuePageRun(): Promise<boolean> {
  console.log("执行到页面还原", pageList.value, operationList.value)
  const pages = JSON.parse(localStorage.getItem("pageList") || "[]")
  const operations = JSON.parse(localStorage.getItem("operationList") || "[]")

  if (!pages.length) {
    return false
  }

  const pageMap: PageMapType = {
    Five,
    Nine,
    BeforeTest,
    Sign,
    CutBox,
    Mixture,
    AfterTest,
    Review,
    Paraphrase,
  }
  // await showLoadingAnimation();

  try {
    // 获取最后一个页面
    const last = operations[operations.length - 1]
    const operationArr = []
    // 筛选与最后一个页面相关的操作
    // 从第一位开始判断，遇到不匹配就停止
    operations.reverse()
    for (let i = 0; i < operations.length; i++) {
      if (operations[i].module === last.module || operations[i].module === "App") {
        operationArr.push(operations[i])
      } else {
        break
      }
    }
    console.log(operationArr, "operationArr")
    // 创建页面副本用于处理
    const pagesCopy = [...pages]

    // // 依次打开所有页面
    // while (pagesCopy.length) {
    //   await queuePageShift(pageMap, pagesCopy)
    // }
    componentOptions.value = pagesCopy[pagesCopy.length - 1]
    // hiddenLoadingAnimation();
    // 等待一段时间后执行操作
    if (operationArr.length) {
      await new Promise((resolve) => setTimeout(resolve, 1000))

      // 依次执行所有操作
      for (const operation of operationArr) {
        await queueOperationShift([operation])
      }
    }

    return true
  } catch (error) {
    console.error("页面还原过程中出错:", error)
    return false
  }
  // finally {
  // hiddenLoadingAnimation();
  // }
}

async function queueOperationRun() {
  if (operationList.value.length) {
    const operationArr = [...operationList.value]
    if (operationArr.length) {
      // while (operationArr.length) {
      //   queueOperationShift(operationArr);
      // }
    }
    return true
  }

  return false
}

// 显示加载框动画
async function showLoadingAnimation() {
  useMsgStore().changeLoadingStatus(true)
  const loading = await loadingController.create({
    message: "加载中...",
  })
  await loading.present()
}

// 隐藏加载框动画
function hiddenLoadingAnimation() {
  loadingController.dismiss()
}

export default {
  pageList,
  queuePagePush,
  queuePageRun,
  queuePageChange,
  queueOperationRun,
  queuePagePop,
  queueOperationPush,
  queuePageClear,
  newQueuePageClear,
}
